<template>
  <div class="cartCategoryPanel">
    <div class="cartCategoryPanel__header">
      Товары <span class="cartCategoryPanel__productCount">{{ productCount }}</span>
    </div>
    <div class="cartCategoryPanel__buttons">
      <check-box
          v-model="selectAll"
          background-color="var(--cd-base-green)"
          tick-color="white"
      >
        <span class="cartCategoryPanel__cmdText">Выбрать все</span>
      </check-box>
      <div class="cartCategoryPanel__roundButton" @click="removeItemsHandler">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.25 4.5H3.75H15.75" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
          <path
              d="M14.25 4.5V15C14.25 15.3978 14.092 15.7794 13.8107 16.0607C13.5294 16.342 13.1478 16.5 12.75 16.5H5.25C4.85218 16.5 4.47064 16.342 4.18934 16.0607C3.90804 15.7794 3.75 15.3978 3.75 15V4.5M6 4.5V3C6 2.60218 6.15804 2.22064 6.43934 1.93934C6.72064 1.65804 7.10218 1.5 7.5 1.5H10.5C10.8978 1.5 11.2794 1.65804 11.5607 1.93934C11.842 2.22064 12 2.60218 12 3V4.5"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M7.5 8.25V12.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M10.5 8.25V12.75" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <div class="cartCategoryPanel__items">
      <div class="cartCategoryPanel__item"
           v-for="item in items"
           :key="item.id"
      >
        <check-box
            background-color="var(--cd-base-green)"
            tick-color="white"
            :modelValue="item.selected"
            @update:model-value="setSelectedItem(item)"
        ></check-box>

        <img
            class="cartCategoryPanel__itemImg"
            :src="item.img_url"
            @click="openImagePreview(item.img_url)"
            @error="(e)=>e.target.src=require('@/assets/img/preview_placeholder.jpg')"
        >
        <div class="cartCategoryPanel__itemDesc">
          <span class="cartCategoryPanel__itemName">{{item.name}}
           <template v-if="item.series">&nbsp;серия {{item.series}}</template>
          <template v-if="item.number">&nbsp;номер {{item.number}}</template>

          </span>
          <span class="cartCategoryPanel__itemPrice">{{item.sale_price}} ₽</span>
        </div>
        <fieldset class="cartCategoryPanel__qnt" >
          <div class="cartCategoryPanel__roundButton" @click="updateQnt(item, -1)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
            {{item.qnt}} шт.
          <div class="cartCategoryPanel__roundButton" @click="updateQnt(item, 1)">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 3.75V14.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M3.75 9H14.25" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
        </fieldset>
      </div>
    </div>

    <div class="cartCategoryPanel__footer">
        <div class="cartCategoryPanel__footerTotal">
            Итого
            <div class="cartCategoryPanel__footerTotalSum">
              {{ totalSum }} ₽
            </div>
        </div>
      <ActionButton
          @button-click="checkoutHandler"
          style="background-color: #6FC062; color: #212226;width: 160px"
      >
        <template #caption>Оформить заказ</template>
      </ActionButton>

    </div>

  </div>
</template>

<script>
import {computed} from "vue";
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import {useCartStore} from "@/store/cart";
import {useToast} from "vue-toast-notification";
import {useRouter} from "vue-router";
import {openImagePreview} from "@/composables/image-preview";


export default {
  name: "CartPanel",
  components: {ActionButton, CheckBox},
  setup() {
    const cartStore = useCartStore();
    const toast = useToast();
    const router = useRouter();
    const productCount = computed(()=> {
      return selectedItems.value.reduce( (acc, item) => {
        return  item.qnt + acc;
      }, 0)
    });

    const items = computed(() => {
      return cartStore.items;
    })

    const selected = computed({
      get() {
        return items.value.filter(item => item.selected).map(item => item.id);
      },
      set(value) {
        cartStore.setSelected(value);
      }
    });


    const loading = computed(() => {
      return cartStore.loading;
    })

    const selectAll = computed({
          get() {
            return items.value.length > 0 && ! items.value.find(item => !item.selected);
          },
          async set(value) {
            if(!value) {
              await cartStore.setSelected([]);
              return;
            }
            await cartStore.setSelected(items.value.map(item => item.id));
          }
        }
    )

    const selectedItems = computed(() => {
      return items.value.filter(item => item.selected);
    });

    const totalSum = computed(() => {
      return (selectedItems.value || []).reduce((acc, item) => (acc + item.sale_price * item.qnt), 0);
    })

    function checkoutHandler() {
      if(selectedItems.value.length <= 0) {
        toast.warning('Не выбраны позиции в корзине')
        return;
      }
      router.push({name: 'CheckoutView'})
    }

    async function updateQnt(item, delta) {
      if(loading.value) {
        return;
      }
      if(item.coin_id && delta > 0) {
        return;
      }
      await cartStore.updateQnt({qnt: item.qnt + delta, id: item.id});
      if(cartStore.error) {
        toast.error("Ошибка изменения количества: " + cartStore.error);
        return;
      }
      console.log("CartStore error", cartStore.error)
    }

    function removeItemsHandler() {
      if (selectedItems.value.length < 1) {
        return;
      }
      cartStore.deleteCart({ids: selected.value});
      if(cartStore.error) {
        toast.error("Ошибка удаления: " + cartStore.error);
        return;
      }
      toast.success("Успешно удалено");
    }

    function setSelectedItem(curItem) {
      if(!curItem.selected) {
         selected.value =  [...selected.value, curItem.id];
         return;
      }
      selected.value = selected.value.filter(itemId => itemId !== curItem.id);
    }

    return {
      productCount,
      selectAll,
      selected,
      setSelectedItem,
      totalSum,
      removeItemsHandler,
      loading,
      updateQnt,
      checkoutHandler,
      items,
      openImagePreview
    }
  }
}
</script>


<style scoped lang="scss">
.cartCategoryPanel {
  display: flex;
  flex-direction: column;
  gap: 24px;
  border-radius: 20px;
  padding: 24px;
  background: var(--cd-card-bg);

  &__header {
    display: flex;
    font-size: 26px;
    color: var(--cd-text);
    gap: 16px;
  }

  &__productCount {
    background: var(--cd-button-bg-color);
    border-radius: 1000px;
    padding: 10px;
    font-size: 12px;
  }

  &__cmdText {
    font-size: 20px;
    padding: 0 10px;
  }

  &__buttons {
    display: flex;
    align-items: center;
  }

  &__roundButton {
    width: 40px;
    height: 40px;
    background: var(--cd-button-bg-color);
    color: var(--cd-text);
    border-radius: 1000px;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  &__item {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    border-bottom: 1px solid var(--cd-spoiler-border-color);
    padding: 20px;

    @include respond-to('sm') { padding: 12px; gap: 12px; }
  }

  &__itemDesc {
    flex: 1 1 200px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    justify-content: start;
    font-size: 20px;
    color: var(--cd-text);

    @include respond-to('sm') { font-size: 16px; }
  }

  &__itemImg {
    border-radius: var(--cd-card-border-radius);
    width: 132px;
    height: 132px;
    object-fit: cover;
    object-position: center;
    cursor: zoom-in;

    @include respond-to('xs') { width: 80px; height: 80px; }
  }

  &__qnt {
    display: flex;
    align-items: center;
    gap: 5px;
    border: none;
  }

  &__footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    gap: $space-sm;
    text-align: left;
  }
  &__footerTotalSum {
    color: var(--cd-success);
    font-size: 20px;
  }
}

</style>
